module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("fWDOt"))).then(() => parcelRequire('7TE64'));